module.exports = {
  联想企业网盘: 'Lenovo Fliez',
  分享: 'Share',
  在线编辑: 'Online editing',
  下载: 'Download',
  更多操作: 'More operations',
  预览: 'Preview',
  本地编辑: 'Edit it locally',
  zOffice编辑: 'zOffice Editing',
  本地打开: 'Open on desktop',
  共享管理: 'Sharing management',
  收藏: 'Favorite',
  取消收藏: 'Unfavorite',
  '添加/编辑标签': 'Add/edit labels',
  历史版本: 'Past versions',
  重命名: 'Rename',
  '移动/复制': 'Move/copy',
  锁定: 'Lock',
  解锁: 'Unlock',
  请求解锁: 'Request unlock',
  删除: 'Delete ',
  新建链接: 'New link',
  安全链接: 'Secure links',
  新建SmartShare: 'New SmartShare',
  查看历史链接: 'View past links',
  病毒: 'Virus',
  确认: 'Confirm',
  取消: 'Cancel',
  提示: 'Tips',
  全部类型: 'All file types',
  图片: 'Images',
  音频: 'Audio',
  幻灯片模式: 'Slide mode',
  预览模式: 'Preview mode',
  链接下载工具: 'Link Download Tool',
  // vvvvvvvvvvvvvvvv历史版本相关的翻译vvvvvvvvvvv
  '版本说明:': 'Version description:',
  版本说明: 'Version description',
  创建: 'Create',
  更新: 'Update',
  恢复: 'Restore',
  最新: 'Current',

  // 重命名
  点击可重命名: 'Click to rename',
  重命名成功: 'Renamed successfully',
  文件名称不能包括下列任何字符: 'File name must not include any of the following characters',
  名称不能为空: 'The name cannot be empty',
  '如果改变文件扩展名，可能会导致文件不可用。确实要更改吗？': 'If you change the filename extension, the file may become unusable. Are you sure you want to change it?',
  // 新手引导
  选出想连续查看的文件类型: 'Select the file types you want to view',
  全屏查看: 'View in full screen',
  // pdfjs遗漏加载过程 start
  内容展现快慢和内容复杂度有很大关系: 'The speed at which content is displayed is closely related to the complexity of the content',
  '工程师  云波': 'Engineer Yunbo',
  '加水印的重要文件，每次打开都要更新水印内容，请耐心等候': 'The watermark content in important files needs to be updated each time such files are opened. Please wait patiently.',
  '安全工程师  老王': 'Security engineer Mr. Wang',
  '内容有特殊格式，打开速度可能会受影响': 'The content of this file is in a special format. This may affect the speed it is opened.',
  '工程师  老胡': 'Engineer Mr. Hu',
  '常用文件在移动端离线查看，断网也不怕': "Commonly used files can be viewed offline on the mobile client. Users don't need to worry about network interruption",
  '销售  清风': 'Salesperson Qingfeng',
  '内容复杂度不同，预览加载时间也不同': 'The loading speed for previews varies depending on the complexity of the content',
  '美女工程师  海曦': 'Beauty engineer Haixi',
  '预览过的文件，再次预览的速度会更快': 'Previously previewed files will load faster when viewed again',
  '客服经理  立法': 'Customer service manager Lifa',
  PPT文档可直接在线播放: 'PPT documents can be viewed directly online',
  '销售  小新': 'Salesperson Xiaoxin',
  '预览界面的右侧栏中可添加评论，@其他共享者，便于交流过程存档': 'Comments can be added in the column on the right of the preview interface. Mention (@) other sharers to make it easier to archive the communication.',
  '产品经理  标标': 'Product manager Biaobiao',
  'CAD、3D文件复杂，预览转换还请耐心等候': 'CAD and 3D files are complex. When converting files for preview, please wait patiently.',
  '产品经理  智文': 'Product manager Zhiwen',
  'PS文件可在线查看，既方便又省电脑空间': 'PS files can be viewed online, which is convenient and saves disk space',
  '设计师 昆昆': 'Designer Kunkun',
  '培训资料可直接播放讲解，方便又好管理': 'Training materials can be viewed directly, making it convenient and easy to manage files',
  'HR 晓东': 'HR Xiaodong',
  '正在切换预览模式，请稍候...': 'Switching the preview mode. Please wait...',
  // pdfjs遗漏加载过程 end
  // 右侧栏start==============================
  '7天内': 'Within 7 days',
  '15天内': 'Within 15 days',
  '30天内': 'Within 30 days',
  '45天内': 'Within 45 days',
  '60天内': 'Within 60 days',
  评论: 'Comment',
  详情: 'Details',
  '共{n}项': '{n} items',
  文件动态: 'File dynamics',
  文件属性: 'File properties',
  更新时间: 'Update time',
  本地修改时间: 'Local update time',
  创建者: 'Created by',
  备注: 'Remarks',
  类型: 'Type',
  查看详情: 'View details',
  路径: 'Path',
  引用地址: 'Quick access link',
  暂无评论: 'No comments',
  '是否删除该评论？': 'Are you sure you want to delete the comment?',
  '查看{n}条回复': 'View {n} replies',
  收起更多: 'Collapse more',
  回复: 'Reply',
  刚刚: 'Just now',
  分钟前: 'minute(s) ago',
  今天: 'Today',
  昨天: 'Yesterday',
  前天: 'The day before yesterday',
  '输入备注文字，最多100个字符': 'Input remarks in no more than 100 characters',
  路径已成功复制到剪贴板中: 'The path has been successfully copied to the clipboard',
  复制成功: 'Copy successfully',
  正在加载: 'Loading',
  动态详情: 'Dynamic details',
  全部: 'All',
  关闭: 'Close',
  '请输入评论，限制200字符': 'Input comments in no more than 200 characters',
  '@提醒他': 'Remind him',
  所有人: 'Everyone',
  发送: 'Send',
  编辑: 'Edit',
  复制: 'Copy',
  无匹配的人: 'No matching users',
  大小: 'Size',
  创建时间: 'Creation time',
  过期时间: 'Expiration time',
  链接说明: 'Link description',
  文件密级: 'User security classification',
  // 右侧栏end==============================
  下载查看: 'Download and view',
  文件已损坏: 'The file is corrupted',
  该文件已被删除: 'The file was deleted',
  类型的文件不支持预览: 'Files can’t be previewed',
  没有权限查看该文件: 'No permission to view the file',
  '受文件密级管控规则限制，无法查看高密级文件': 'Restricted by file security classification control rules, high security classification files cannot be viewed.',
  '当前用户无法访问该文件，请联系管理员': 'The file cannot be accessed by the current user.Please contact the administrator.',
  '该文档大小超过{n}，为了提供稳定的预览体验，目前仅支持下载查看': 'To provide a stable preview, documents exceeds {n} cannot be previewed. Please download and open it on your device',
  '该文档大小超过{n}暂不支持在线预览': 'Online preview is not supported when the document size exceeds {n}',
  '为了提供稳定的预览体验，目前仅支持下载查看': 'To provide a stable preview, please download and open it on your device',
  '如果您没有下载权限，请联系文件授权者或者系统管理员': 'If you don\'t have the download permission, please contact the file authorizer or system administrator',
  返回到预览界面: 'Back to the preview page',
  '啊哦，出错了…': 'Oops. An error occurred...',
  连接问题或文件损坏会导致预览无法加载: 'Connection problems or corrupted files can prevent previews from loading',
  '5分钟后可再次尝试，或联系系统管理员': 'Try again in 5 minutes or contact the admin',
  返回: 'Back',
  已标记: 'Marked',
  设为最新: 'Set as current',
  设为最新版本: 'Set as current',
  在新标签页打开: 'Open in new tab',
  标记版本: 'Mark this version',
  编辑版本标记: 'Edit version',
  添加说明: 'Add description',
  查看说明: 'View description',
  '请输入版本说明, 最多可输入200个字符或汉字': 'Input version description, up to 200 words',
  'Emm...视频加载失败': 'Emm....Video load failed',
  '我们也不希望看到这种情况，请您检查:': 'This is not working properly, here is what you can do:',
  网络链接是否正常: 'Check the network',
  视频文件是否损坏: 'Whether the video file is corrupted',
  '音频正在转码，暂时无法播放，请稍后重试': 'The audio is transcoding, unable to play temporarily. Please try again later',
  '视频正在转码，暂时无法播放，请稍后重试': 'The video is transcoding, unable to play temporarily. Please try again later',
  重试: 'Retry',
  'Emm...音频加载失败': 'Emm....Audio load failed',
  音频文件是否损坏: 'Whether the audio file is corrupted',
  // 底部栏 start
  展开列表: 'Show list',
  收起列表: 'Hide list',
  下一个: 'Next',
  上一个: 'Previous',
  加载中: 'Loading',
  // 底部栏 end
  // 图片组件 start
  原图: 'Original image',
  标准: 'Standard',
  此图片无法查看原图: 'Its original image cannot be viewed',
  此格式文件无原图预览功能: 'Files in this format do not support the function of previewing the original image',
  已显示原图: 'Original image shown',
  已显示标准: 'Default image shown',
  目前已是原图: 'Original image shown',
  超出文件预览上限: 'File preview limit exceeded',
  '抱歉，您没有权限预览该文件，您可选择下载到本地或转存至网盘': 'Sorry, you do not have permission to preview this file, you can choose to download to the local or save to the zBox',
  // 图片组件 end
  // 删除 start
  将为您重新获取列表文件: 'Reload the list file for you',
  请返回列表查看: 'Return to the file list',
  当前预览的文件夹已被删除: 'The currently previewed folder has been deleted',
  当前预览的文件: 'The currently previewed file ',
  已被删除: ' has been deleted',
  // 删除 end
  // 类型选择翻译 start
  文档: 'Document',
  其他: 'Others',
  视频: 'Video',
  音频: 'Audio',
  // 类型选择翻译 end
  保存: 'Save',
  添加: 'Add',
  '视频转码中，请耐心等待': 'Video transcoding is in progress. Please wait',
  版本: 'Version',
  返回到文件所在的列表: 'Return to the list of files',
  '添加标记，限10个字符': 'Add mark (limited to 10 characters)',
  '确认将{n}版本设为最新版本?': 'Confirm the {n} version as the current version?',
  已设为最新版本: 'Set to current version',
  '音频转码中，请耐心等待': 'The audio is transcoding, please be patient',
  显示比例: 'Display scale',
  注销: 'Logout',
  // 异常页面start
  刷新重试: 'Refresh and try again',
  该分享需要登录查看: 'This share requires login to view',
  去登录: 'To log in',
  // 评论start
  点击下载: 'Click to download',
  发送成功: 'Sent successfully',
  '发送失败，请重新发送': 'Failed to send it. Please resend.',
  新建安全链接: 'New secure link',
  '企业空间根目录下无法@成员': 'Unable to @ members in enterprise space root directory',
  '邮箱：': 'Email:',
  '没有更多评论了…': 'No more comments...',
  本周: 'This week',
  更早: 'Earlier',
  还原: 'Reset',
  // 评论end
  // 提示start
  链接: 'Link',
  成功: 'Success',
  图标显示: 'Icon display',
  列表显示: 'Displayed in a list',
  文件名: 'File name',
  项目名称: 'Item',
  '更新时间 (人)': 'Update time (updated by)',
  时间: 'Update time',
  打包下载: 'Pack it up and download it',
  已到最后: "It's already the end",
  选择排序方式: 'Select a sorting method',
  '已选中{len}项': '{len} items selected',
  ' 由<span title="{n}" class="update-creator">{n}</span>创建': ' Created by <span title="{n}" class="update-creator">{n}</span>',
  文件不存在: 'File does not exist',
  文件夹不存在: 'The folder does not exist',
  // 外链相关start
  登录: 'Login',
  打开: 'Open',
  转存至网盘: 'Save to zBox',
  链接已失效: 'The link has expired',
  该链接已被取消或超过有效期: 'This link has been cancelled or out of dated.',
  您可以联系链接发送者: 'You can contact the link sender',
  留言: 'Leave a message',
  软件: 'Software ',
  发件人: 'Sender',
  收件人: 'Recipient',
  '{n}的分享': '{n}',
  '{n}的申请': "{n}'s application",
  转存: 'Transfer',
  成功创建文件夹: 'Folder created successfully',
  文件转存成功: 'File transferred and saved successfully',
  请选择将要保存的文件: 'Please select a file to be saved',
  点击查看: 'Click to view',
  已成功保存文件: 'Saved successfully',
  新建文件夹: 'New folder',
  所有目录: 'All directories',
  企业空间: 'Enterprise space',
  个人空间: 'Personal space',
  个人文件: 'Personal files',
  我的共享: 'My shared files',
  收到的共享: 'Shared with me',
  内容: 'Contents',
  请输入邮箱: 'Please enter email',
  请输入右侧的验证码: 'Please enter the right verification code',
  '请输入回复内容，最多300个字': 'Please enter the reply, up to 300 words',
  免费试用: 'Free Trial',
  验证码错误: 'Incorrect verification code',
  请输入正确的邮箱格式: 'Input email address in the correct format',
  验证码不能为空: 'Verification code must not be empty',
  请输入回复内容: 'Input reply contents ',
  获取验证码: 'Verification code',
  重新发送: 'Resend',
  提交: 'Submit',
  已删除: 'Deleted',
  '用户名：': 'Username: ',
  未设置有效期: 'No validity period set',
  '发送中...': 'Sending...',
  验证码已发送至手机: 'The verification code has been sent to your mobile phone',
  '验证码已发送至手机，您还能发送{n}次验证码': 'Verification code has been sent to you, you can send {n} verification code',
  '@某成员通知其查看': 'Use "@name" to notify a member to view',
  '请输入邮箱/手机号和验证码后查看文件：': 'Input your email or mobile and verification code to view the file: ',
  '请输入邮箱/手机号后查看文件：': 'Input your email or mobile to view the file: ',
  '您的信息仅对分享人可见，不会被泄漏，请放心填写': "Your information is only visible to the sharing user and won't be revealed to others. ",
  请输入邮箱或手机号: 'Input your email or mobile number',
  请输入手机号: 'Input mobile number',
  请输入验证码: 'Enter verification code',
  '验证码不正确，请重新输入': 'Incorrect verification code. Please re-enter ',
  请输入提取密码: 'Input the access code',
  确定: 'Confirm',
  提取码不能为空: 'The access code cannot be empty',
  保存到手机: 'Save to phone',
  请联系链接创建者了解具体情况: 'Please contact the creator of the link for details',
  该链接未生效: "The link doesn't work",
  '2.联系客服：400-898-7968': '2.Contact customer service: 400-898-7968',
  暂无权限: 'No permission',
  '当前用户无权查看该分享，请联系分享人': 'The current user is not authorized to view this link, please contact the sharer',
  '体验版不支持预览，请升级版本': "The trial version doesn't support preview, please upgrade the version",
  '北京联想协同科技有限公司 版权所有 京ICP备11035381': 'Copyright© Beijing Lenovo Collaborative Technology Co., Ltd. 京ICP备11035381',
  '是否注销当前账号？': 'Do you want to log out?',
  '该文件的安全级别较高，您需要下载专用软件才可以使用（仅支持windows用户）': 'This file has a high level of security, and you need to download software to use it (only for windows users)',
  最多可输入300个字符: 'Enter up to 300 characters',
  返回列表: 'Back to list',
  '您今天验证次数过多，请明天或换个手机号试试': 'You have too many verifications today, please try tomorrow or use other mobile number',
  '验证码发送失败，请重试': 'Verification code failed, please try again',
  请输入正确的邮箱或手机号格式: 'Please enter the correct email or mobile number',
  '网络错误，请重试': 'Connection error, please try again',
  还没有动态信息: 'No updates information',
  '搜索国家/地区': 'Search for countries/regions',
  未找到相关国家或地区: 'No related countries or regions found',
  常用: 'Frequently used',
  给您分享了一个文件: 'Shared with you',
  邮箱或国内手机号验证: 'Email or China mobile',
  国际手机号验证: 'International mobile',
  请输入正确的手机号格式: 'Please enter the correct phone number',
  提取码输入错误: 'Incorrect password',
  上传: 'Upload',
  '确认取消所有未完成的任务？': 'Sure to delete all the unfinished tasks?',
  目标文件禁止此操作: 'This operation is forbidden on the target file',
  '文件下载次数已用尽，请联系链接创建者！': 'The number file downloads has run out. Please contact the link creator!',
  请您先选择文件: 'Select a file first',
  '该文件夹下包含的文件数量超过200条，无法下载': 'Unable to download, the number of files exceeds 200',
  继续下载: 'Continue to download',
  '部分文件无下载权限，继续下载将会过滤这些文件': 'You don’t have permission to download some files. If you continue to download, these files will be filtered',
  选中文件总大小超过5G无法下载: 'Unable to download, the total size of the selected file exceeds 5G',
  批量操作数量不能超过100: 'You may operate no more than 100 in bulk.',
  小时: 'Hour(s)',
  '1小时': '1 hour',
  '1分钟': '1 minute',
  分钟: ' minute(s)',
  '1天': '1 day',
  天: ' day(s)',
  后: ' Later',
  密码错误: 'Wrong password',
  '体验版本不支持在线预览，请升级版本': 'Online preview is not supported for the demo version. Please update the version ',
  验证码已发送至邮箱: 'The verification code has been sent to your email',
  '网络错误,请重试': 'Network connection error, please try again',
  文件夹为空: 'Folder is empty',
  '很抱歉，您的操作失败了，建议您重试一下！': 'Sorry, your operation failed. Please try again!',
  '网络状态不稳定，请稍后再试': 'Network connection is not stable. Try again later.',
  点击刷新: 'Click to refresh',
  刷新: 'Refresh',
  不支持搜索: 'Search is not supported',
  搜索文件夹: 'Search for folders',
  '搜索范围：': 'Search range:',
  暂不支持搜索: 'Search is not supported here',
  无符合条件的搜索结果: 'No matching search results',
  该链接密码已失效: 'The link password has expired',
  请重新输入密码: 'Please re-enter your password',
  扫描二维码在手机上查看: 'Scan QR code to view on mobile phone',
  重新输入: 'Re-enter your password',
  没有操作权限: 'No operation permission',
  知道了: 'OK',
  // 外链相关end
  // 品牌升级预热 start
  全新品牌升级敬请期待: 'New brand update to look forward to',
  // 品牌升级预热 end
  // 上传 start
  已完成: 'Completed',
  上传列表: 'Upload list',
  上传至: 'Upload To',
  取消所有: 'Cancel all',
  剩余时间: 'Time left',
  '选择的目录空间不足，保存失败': 'Not enough space selected, save failed',
  目前不支持上传大于1G的文件: 'Uploading files larger than 1G is currently not supported',
  '文件名称不能以.开头': 'File name can not start with point',
  // 上传 end
  试用全新品牌: 'Try a new brand',
  审批申请: 'Apply for approval',
  '该内容的操作需经过审批后才可生效，是否提交审批？': 'This operation must be approved before taking effect. Are you sure you want to submit it for approval?',
  审批者: 'Approved by',
  可添加审批申请说明: 'You can add explanation for applying for approval',
  '审批已提交，请等待审批结果，通过后，链接立即生效': 'It has been submitted for approval. Please wait for the approval result. The link will take effect immediately once approved.',
  // 链接分享 start
  链接分享: 'Link sharing',
  外链: 'External link',
  还没有创建分享链接: 'Links have not been created yet',
  创建链接: 'Create',
  保存并复制: 'Save and Copy',
  二维码: 'QR code',
  '手机扫描快速分享链接至微信、QQ 等好友': 'Scan QR code to quickly share file',
  '备注名：': 'Remarks name:',
  '提取码：': 'Password:',
  提取码: 'Access code',
  '权限：': 'Permissions:',
  允许上传: 'Upload',
  允许下载: 'Download',
  允许预览: 'Allow preview',
  仅内部成员可用: 'For internal members only',
  '安全：': 'Security:',
  取消加密: 'Cancel encryption',
  有效期: 'Validity period',
  '距到期还有{d}天{h}时{m}分': '{d}d, {h}h {m}m left',
  时: 'hour',
  分: 'minute',
  链接已过期: 'Link expired',
  可下载次数: 'Downloads',
  始终链接到文件最新版本: 'Always link to the latest version of the file',
  '关闭此项，链接仅保持当前内容': 'If you close this item, the link only keeps the current content',
  '说明：': 'Description:',
  '说明:': 'Description:',
  添加链接说明: 'Add link description',
  '邮箱:': 'Email:',
  创建新链接: 'Create a new link',
  管理历史链接: 'Manage past links',
  '删除链接, 会导致链接失效': 'If you delete the link, it will become invalid',
  '是否确认删除?': 'Are you sure you want to delete it?',
  您只能创建上传链接: 'You can only create upload links',
  '因受到公司更高安全级别的链接安全管控规则限制，无法创建SmartShare': 'SmartShare cannot be created due to restrictions of link security control rules at a higher security level of the company',
  普通链接: 'Normal links',
  无限制: 'Unlimited',
  '未实名认证账号，只能创建内部分享链接': 'You can only create internal share links.',
  该链接需要审批后生效: 'The link will take effect upon approval',
  '审批中....该链接需要审批后生效': 'Approving... This link must be approved before taking effect',
  '审批未通过，': 'Rejected,',
  '查看未通过原因，': 'Check why it failed',
  您可以修改原链接或者创建新链接: 'You may modify the original link or create a new link',
  需要审批: 'It requires approval',
  阅读次数: 'Views',
  阅读时长: 'Reading time',
  允许打印: 'Allow printing',
  文档只读: 'Read-only',
  失效后删除: 'Delete after expiration',
  添加阅读水印: 'Add "Viewed" watermark',
  按照文件创建者搜索: 'Search by file creators',
  无相关搜索结果: 'No related results found',
  链接地址已经复制到剪切板中: 'Link address copied to clipboard',
  邮箱不能为空: 'The email address cannot be empty',
  请至少选择一种权限: 'Please select at least one permission',
  '以下标红的邮箱格式不正确，检查一下吧': 'The format of the following email addresses marked in red is wrong. Please check.',
  下载次数已用尽: 'The number of downloads has run out',
  '点击或输入邮箱地址，多个地址以逗号或分号分隔': 'Click or input an email address. Multiple addresses should be separated by commas or semicolons',
  '“允许下载/预览”和“允许上传”不可同时选择': '"Allow download/preview" and "Allow upload" must not be selected at the same time',
  阅读次数已用尽: 'The maximum number of viewing times has run out',
  阅读时长已用尽: 'The viewing duration time has run out',
  最多可下载: 'You may download a maximum of',
  最多可阅读: 'You may view a maximum of',
  // 链接分享 end
  // 历史链接弹框开始
  历史链接: 'Past links',
  还没有创建过链接: 'No link has been created',
  点击创建链接: 'Create links',
  状态: 'Status',
  权限: 'Permissions',
  '有效期：': 'Validity period:',
  '范围：': 'Scope:',
  '已下载次数：': 'Number of downloads:',
  全部清除: 'Clear all',
  审批中: 'Under review',
  未通过审批: 'Rejected',
  已失效: 'Expired',
  使用中: 'In use',
  所有人可见: 'Visible to all',
  加密: 'Encryption',
  已过期: 'Expired',
  天后过期: 'Expires in x day(s)',
  无限次下载: 'Unlimited downloads',
  剩余可下载: 'Remaining downloads',
  次: 'Times',
  '版本标记：': 'Version tag:',
  '版本说明：': 'Release notes:',
  '是否确认删除？': 'Are you sure you want to delete it?',
  // 历史链接弹框结束
  // LD WEB TOOL start
  '安装zBox WebTool插件': 'Install Plug-in zBox WebTool',
  'zBox WebTool插件': 'Plugin zBox WebTool',
  '请下载并安装zBox WebTool插件进行操作': 'Please download and install the plug-in zBox WebTool',
  '安装后，再次点击此按钮，即可在电脑上继续执行操作': 'After installation, click this button again to continue.',
  文件大小超出上限: 'File size exceeds the upper limit',
  本地编辑文件大小上限200MB: 'The upper limit of a file that can be edited locally is 200 MB',
  '为了更好的编辑体验，请您下载后在进行编辑': 'For a better editing experience, please download it before editing',
  'zBox WebTool被占用': 'zBox WebTool is being used',
  '当前计算机上的zBox WebTool已被占用，请先关闭任务，再重试': 'zBox WebTool on the current computer is being used. Close the task first and try again',
  继续退出: 'Continue to exit',
  'zBox WebTool正在运行': 'zBox WebTool is running',
  'zBox WebTool有正在传输的任务，是否要退出？': 'zBox WebTool is performing a transmission task. Are you sure you want to exit?',
  查看文件: 'View file',
  '有文件正在编辑中，继续退出可能会导致文件内容丢失': 'A file is being edited. If you continue to exit, file contents may be lost',
  请关闭文件等待自动保存完成后退出: 'Close the file and wait for it to be automatically saved before exiting',
  未检测到可打开该文件的应用程序: 'No application that can open the file is found',
  '未检测到插件zBox WebTool，请重试安装': 'The editor plugin zBox WebTool was not found. Please retry to install it.',
  '在该电脑上未检测到插件zBox WebTool，请重试安装或检查 Firefox浏览器设置。': 'The editor plugin zBox WebTool was not found on the computer. Please try to install it again or check the Firefox browser settings.',
  '如果已安装zBox WebTool，请直接运行': 'If zBox WebTool is installed, please run directly',
  '如果未安装zBox WebTool，请下载并安装': 'If zBox WebTool is not installed, download and install',
  我已安装: 'Already Download',
  下载插件: 'Download',
  图标: 'Icon',
  '1.下载已经自动开启，如未开始，': '1. Download has started automatically. If it has not started,',
  点击此处重试: 'Click here to try again',
  '2.下载完成后，请双击安装程序，按照说明继续操作': '2. After you complete the download, please double click the installation program and follow the instructions to continue',
  '3.完成安装程序后，点击继续': '3. After you install the program, click to continue',
  文件格式: 'File format',
  'Windows 记事本': 'Windows Notepad',
  '您的浏览器版本过低,请升级到最新版本后重试': 'Your browser version is too old. Try again after upgrading your browser to the latest version.',
  '浏览器要求:': 'Requirements for browser:',
  'IE9及以上、IE edge、Chrome、Firefox4及以上、Safari5及以上、Opera11.5及以上': 'IE9 and later, IE edge, Chrome, Firefox 4 and later, Safari 5 and later, Opera 11.5 and later',
  请升级您的浏览器版本: 'Upgrade your browser version',
  了解如何设置: 'Learn how to set up',
  '该审批规则没有审批者，请联系管理员': 'There is no approver for the approval rule, please contact the administrator',
  添加提取码: 'Extraction code',
  添加水印: 'Add watermark',
  '该文件类型，需开启本地管控才可添加水印': 'Turn on local control and add watermark.',
  设置增强链接安全性: 'Set enhanced link security',
  文件快照: 'File snapshot',
  登录认证: 'Login authentication',
  链接已复制成功: 'The link has been replicated successfully',
  链接和密码已复制成功: 'Links and passwords have been replicated successfully',
  添加邮件说明: 'Add mail description',
  网盘同事: 'Colleague',
  允许预览文件: 'Preview',
  继续: 'Continue',
  手机扫描二维码查看链接: 'Mobile phone scanning QR code to view the outer chain',
  发邮件分享链接: 'Email sharing link',
  '新建链接时勾选此项后不可取消。链接路径下所有文件以副本形式存在，不受源文件内容的增删和更新影响。': 'When new links are checked, this item cannot be cancelled.All files in the link path exist as a copy, and are not affected by the addition, deletion, and update of the contents of the source file.',
  开启登录认证后此链接需要登录网盘账户才可访问: 'The link needs to be logged in to the Cloud account to be accessible,because the login authentication is enabled.',
  '可通过设置，限制该链接的文件下载到本地的操作，目前仅支持windows系统': 'Can control the operation of the linked file after downloading to the local, currently only supports Windows system',
  '新建中...': 'Creating...',
  添加链接提取码: 'Expiration code',
  添加链接有效期: 'Expiration date',
  开启本地管控: 'Turn on local control',
  添加本地密码: 'Local password',
  添加阅读有效期: 'Reading date',
  限制阅读次数: 'Opening times',
  限制阅读时长: 'Reading time',
  限制下载次数: 'Downloads limited',
  请输入正整数: 'Please enter integer',
  请配置本地管控规则: 'Please configure local control options',
  新建的安全链接: 'New security link',
  请输入水印内容: 'Please enter watermark',
  '文件下载至本地查看会附带水印，但不可打包下载和下载文件夹。': 'View the local download file will be accompanied by a watermark but not packaged and downloaded folders.',
  密码只能包含字母或数字: 'Passwords can only contain letters or numbers',
  '温馨提示：您当前的浏览器版本过低，可能导致部分功能无法正常使用，为保证您的使用体验，请尝试升级浏览器或下载其他浏览器访问，谢谢。谷歌浏览器（Chrome），火狐浏览器（Firefox），Edge': 'Your browser version is too low, which may cause some functions to be unable to use properly. In order to ensure your experience, please update your browser or download other browsers to access, thank you.Chrome, Firefox',
  // LD WEB TOOL end
  '用户不能@自己!': "Users can't @ themselves",
  '用户最多能@10个人!': 'You can @ up to 10 users',
  正在提交: 'Submitting',
  '@所有人': '@everyone',
  加入版本对比: 'Add for comparison',
  请选择另1个版本进行比较: 'Please add another version',
  点击对比2个版本: 'Click to compare',
  '此目录设置了审批规则，禁止对比版本': 'This directory set approval rules prohibits comparing versions',
  '此目录因设置了审批规则,无法执行此操作': 'This operation cannot be executed because the directory sets the approval rules',
  '该文件/文件夹已被删除，无法进行操作': 'The file has been deleted and cannot be operated on',
  '用户不能@同一个人!': 'Users can\'t @ the same person',
  '每条评论只允许@所有人一遍!': 'Each comment is only allowed to @everyone once!',
  '浏览器已禁止访问，请联系您的管理员': 'Web access is forbidden, please contact administrator',
  摆渡审批详情: 'Details of ferry approval',
  流水号: 'Serial number',
  发起时间: 'Initiation time',
  待审批: 'Waiting for approval',
  已同意: 'Approved',
  未通过: 'Not through',
  未提交: 'Unsubmitted',
  查看摆渡详情: 'Check details',
  发起者: 'Originator',
  定时摆渡: 'Scheduled ferry',
  审批意见: 'Feedback',
  申请理由: 'Application reason',
  摆渡通道: 'Exchange channel',
  来源路径: 'Source path',
  接收路径: 'Receive path',
  摆渡外发详情: 'Details of exchange sending',
  摆渡接收详情: 'Details of exchange reception',
  摆渡内容: 'Exchange content',
  安全扫描中: 'Security scanning',
  等待发送: 'Waiting to send',
  发送失败: 'Send failed',
  禁止发送: 'No sending',
  发送中: 'Sending',
  等待提取: 'To be extracted',
  转存失败: 'Transfer failed',
  转存成功: 'Successfully transferred',
  任务异常: 'Abnormal  termination',
  转存中: 'Transferring',
  包含敏感信息禁止摆渡: 'No exchange for sensitive information',
  包含病毒禁止摆渡: 'No exchange for virus',
  审批拒绝: 'Approval rejected',
  服务器连接失败: 'Server connection failed',
  敏感信息扫描失败: 'Sensitive information scan failed',
  病毒扫描失败: 'Virus scan failed',
  审批规则不存在: 'No approval rules',
  审批过期: 'Approval expired',
  通道不存在: 'No channel',
  审批失效: 'Approval invalid',
  对摆渡文件无下载权限: 'No download permission for exchange files',
  文件类型不允许摆渡: 'File type prohibited exchange',
  文件过大: 'File is too large to exchange',
  文件数量超过上限: 'The number of files exceeds the limit',
  接收规则不存在: 'No receiving rules',
  未匹配到接收用户: 'No receiving user',
  接收用户状态异常: 'The status of the receiving user is abnormal',
  接收路径不存在: 'No receiving path',
  接收者在接收路径无权限: 'The receiver has no permission for the receiving path',
  接收路径空间不足: 'Insufficient space for receiving path',
  接收路径有上传审批: 'Approval is required when uploading on the receiving path',
  存在锁定同名冲突文件: 'There is a locked file with the same name',
  存在不允许上传的格式: 'The selected items include types that are not allowed to upload',
  // 文件保护状态
  保护状态: 'Protected',
  该表格处于保护状态: 'The form is protected',
  该文档处于保护状态: 'The file is protected',
  '本地打开、更新版本、移动等操作可能受限。': 'Some operations such as opening locally, updating and <br/> moving may be restricted.',
  '在zOffice编辑中关闭"<strong>允许区域保护</strong>"项可恢复非保护状态。': 'To restore the unprotected state, please turn off "<strong>Allow <br/> area protection</strong>" in zOffice Editing.',
  '联系所有者 {t} 在zOffice编辑中关闭"<strong>跟踪更改</strong>"可恢复非保护状态。': 'To restore the unprotected state, please contact the file <br/> owner {t} to turn off "<strong>Track changes</strong>" in zOffice Editing.',
  '在zOffice编辑中关闭"<strong>跟踪更改</strong>"可恢复非保护状态。': 'Turn off "<strong>Track Changes</strong>" in zOffice Editing to restore the file to <br/> an unprotected state.',
  '该文件处于保护状态，为保障数据安全，暂时无法访问其他历史版本': 'Because the file is protected, to ensure data security, other historical versions cannot be accessed temporarily',
  该格式的文件需要在浏览器中打开预览: 'Files of this format type can only be previewed in the browser',
  在浏览器打开: 'Open in browser',
  '文档超过50M,不支持下载水印': 'The document exceeds 50M, downloading watermark is not supported',
  '文件总数超过200条，请分批下载或通过电脑客户端下载':
    'The total number of files exceeds 200, please download in batches or download through the computer client',
  '文件总大小超过5GB，请分批下载或通过电脑客户端下载':
    'The total file size exceeds 5GB, please download in batches or download through the computer client',
  '文件总数超过200条，请分批下载': 'The total number of files exceeds 200, please download in batches',
  '文件总大小超过5GB，请分批下载': 'The total file size exceeds 5GB, please download in batches',
  '文件总数超过200条，请分批下载或通过WebTool下载':
    'The total number of files exceeds 200, please download in batches or download through WebTool',
  '文件总大小超过5GB，请分批下载或通过WebTool下载':
    'The total file size exceeds 5GB, please download in batches or download through WebTool',
  '当前文件过大建议使用Web Tool下载，更稳定，更快速':
    'The current file is too large. It is recommended to download it with WebTool, which is more stable and faster',
  通过WebTool下载: 'Download by WebTool',
  '存在未完成的传输任务，退出登录后会暂停，是否继续': 'There are unfinished transfer tasks. They will be paused after logging out. Do you want to continue',
  敏感信息管控: 'Sensitive information control',
  '包含敏感信息，命中{n}策略': 'Sensitive information is detected, hitting the policy{n}',
  '已选中 {n}项': 'Selected {n}',
  '打开压缩包需要你拥有文件的预览权限，请联系文件授权者或者系统管理员申请权限打开压缩包需要你拥有文件的预览权限，请联系文件授权者或者系统管理员申请权限': 'You must have the preview permission of the file to open the zip file. Please contact the file authorizer or administrator to apply for permission',
  '正在从压缩包中提取文件，请稍等': 'Extracting files from the zip file',
  时间根据压缩包大小不等: 'Time varies according to the size of the zip file',
  暂时支持2G以内的压缩包在线预览解压: 'Temporarily support online preview and decompression of zip files within 2G',
  压缩包内文件数量超限: 'The number of files in the zip file exceeds the limit',
  '解压异常，请稍后重试或者下载后解压': 'Extracting exception, please try again later or unzip after downloading',
  暂不支持文件名加密压缩包在线解压: 'Online decompression of zip files with encrypted filenames is not currently supported',
  压缩包打开失败: 'Failed to open zip file',
  '您没有预览权限，请联系文件授权者或者系统管理员申请文件预览权限': 'You do not have preview permission, please contact the file authorizer or administrator to apply for file preview permission',
  返回上一级: 'Back',
  '已选中{n}个文件/文件夹': '{n} files/folders selected',
  文件大小: 'File size',
  文件夹内无文件: 'There are no files in the folder',
  全部解压到: 'Extract all to',
  解压到: 'Extract to',
  请选择解压位置: 'Please select an extract location',
  解压并下载到本地: 'Extract and download to local',
  解压到网盘: 'Extract to zBox',
  解压到压缩包所在目录: 'Extract to the directory where the zip file is located',
  选择其他目录: 'Choose another directory',
  '该目录配置了管控规则，无法解压到该目录': 'This directory is configured with control rules and cannot be extracted into this directory',
  '文件正在解压中，请稍后...': 'The file is being extracted, please wait...',
  '解压成功！请点击查看': 'Extracted successfully! Please click to view',
  '当前有文件正在解压，请稍后再试': 'There are files currently being extracted, please try again later',
  '解压到云端的目录存在文件格式限制，解压成功{m}个文件，已自动过滤{n}个文件，如有疑问请联系系统管理员。请点击查看': 'There is a file format limitation for the directory unzipped to the cloud. {m} files were unzipped successfully, and {n} files have been filtered automatically. Please contact the administrator if you have any questions. Please click to view',
  '当前目录因受管控限制，无法解压并下载到本地': 'The current directory cannot be extracted and downloaded locally due to restrictions on control',
  '当前目录因受管控限制，无法解压到其他目录': 'The current directory cannot be extracted to another directory due to restrictions on control',
  下载客户端: 'Download client',
  网页目前仅支持单文件解压到本地: 'The webpage currently only supports extracting a single file to the local',
  您可以在客户端进行该操作: 'You can do this on the client side',
  暂时支持5G以内的单文件在线解压: 'Temporarily supports online decompression of a single file within 5GB.',
  您可将压缩包下载到本地进行解压操作: 'You can download it to the local for decompression',
  IE浏览器中暂时支持1G以内的单文件在线解压: 'IE browser temporarily supports unzipping a single file within 1G.',
  您可更换其他浏览器或将压缩包下载到本地进行解压操作: 'You can change to another browser or download the zip file to unzip it locally',
  '文件正在提取中，即将打开...': 'Extracting file, about to open...',
  该文件超出预览上限: 'The file exceeds the preview limit',
  该类型的文件不支持预览: 'This type of file does not support preview',
  请输入压缩包密码: 'Please enter the zip password',
  '密码错误，请重试': 'Incorrect password, please try again',
  '压缩包中的文件设置了不同的密码，请将压缩包下载本地进行访问': 'The files in the zip file are set with different passwords, please download it locally for access',
  立即下载: 'Download',
  移动端扫码下载: 'Mobile scanning download',
  版: '',
  '适用于Android5.0以上': 'Suitable for Android 5.0 and above',
  Android首次配置说明: 'Android Configuration instructions',
  '适用于iOS10.0或以上版本': 'Suitable for iOS10.0 and above',
  iPhone首次配置说明: 'iPhone Configuration instructions',
  适用于: 'Suitable for ',
  Windows盘符版: 'Windows zDrive',
  '适用于10.13和以上版本': 'For version 10.13 and above',
  '适用于Windows7 SP1以上/Windows10': 'Windows7 SP1 and above/Windows10',
  Outlook插件: 'Outlook Plugin',
  '适用于Outlook2010/2013/2016': 'Outlook 2010/2013/2016',
  Linux版: 'Linux',
  '适用于Ubuntu 18.02和以上版本': 'Ubuntu 18.02 and above',
  'Android 客户端配置说明': 'Android Client configuration description',
  '如果您使用标准版移动客户端，初次使用需要进行服务器地址配置': 'If you use the standard APP, you need to configure the server address for the first time',
  '推荐在客户端配置向导，通过扫描下面二维码进行配置；也可以手工输入服务器地址完成配置。': 'It is recommended to scan the following QR Code in the client configuration wizard for configuration; you can also manually enter the server address to complete the configuration.',
  扫一扫: 'Scan',
  '或采用手工配置输入如下地址信息：': 'Or configure to enter the following address information manually:',
  'iOS 客户端配置说明': 'iOS client configuration description',
  '点击下载的应用，出现如下提示，该提示为正常现象': 'Click on the downloaded application, the following prompt, the prompt for the normal phenomenon',
  '点击设置-通用-设备管理：选择信任Lenovo(Beijing)Limited': 'Click Settings - General - Device Management: Select TrustLenovo(Beijing)Limited>',
  '点击进入应用按照提示，扫描一下二维码或手工输入服务器地址完成配置': 'Click into the application follow the prompts, scan the two-dimensional code or manually enter the server address to complete the configuration',
  'iOS、Android客户端首次配置方法说明': 'The first time configuration for the iOS and Android',
  个人文件摆渡: 'Manual-exchange of Personal files',
  个人文件定时摆渡: 'Auto-exchange of Personal files',
  企业空间摆渡: 'Manual-exchange of Enterprise Space',
  企业空间定时摆渡: 'Auto-exchange of Enterprise Space',
  摆渡接收者: 'Exchange recipient',
  摆渡模式: 'Exchange mode'
}
